export const LOGIN_ROLES = {
  ADMIN: 'admin',
  WRITER: 'contributor',
  CLIENT: 'client',
  POWER_CLIENT: 'power-client',
};

export const CABINET_ROUTES = {
  TRENDS: 'trends',
  REPORTS: 'reports',
  COMPANIES: 'companies',
  CREATE_REPORT: 'create-report',
  CREATE_TREND: 'create-trend',
  STAFF: 'staff',
  USERS: 'users',
  CATEGORIES: 'categories',
  HASHTAGS: 'hashtags',
  TYPE_KEYS: 'type-keys',
  GLOSSARY: 'glossary',
  COLLECTIONS: 'collections',
  WORD_CLOUD: 'word-cloud',
  PEOPLE: 'influencers',
  PEOPLE_COLLECTIONS: 'influencers-collections',
};

export const MAIN_ROUTES = {
  MAIN: '/',
  LOGIN: '/login',
  ADMIN: '/admin',
  WRITER: '/contributor',
  CLIENT: '/client',
  POWER_CLIENT: '/power-client',
  ERROR404: '/error404',
  CONTACT_US: '/contact-us',
  PRIVACY_POLICY: '/privacy-policy',
  GLOSSARY: '/glossary',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
};

export const SIDES = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const COLOR_THEMES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  LIGHT: 'light',
  PRIMARY_GRADIENT: 'primary-gradient',
  TRANSPARENT_FULL: 'transparent-full',
  TRANSPARENT_LIGHT_WHITE: 'transparent-light-white',
  TRANSPARENT_LIGHT_WHITE_2: 'transparent-light-white-2',
  LANDING_THEME: 'landing-theme',
};

export const BUTTON_SIZES = {
  MEDIUM: 'medium',
};

export const ROLE_THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
};

export const SELECT_ITEM_TYPES = {
  USER: 'user',
  COMPANY: 'company',
};

export const SOCIAL_STAT_TYPES = {
  VIEW: 'views',
  LIKE: 'likes',
  COMMENT: 'comments',
  SHARE: 'shares',
};

export const NOTIFICATION_TYPES = {
  REPORT_APPROVED: 'REPORT_APPROVED',
  REPORT_REJECTED: 'REPORT_REJECTED',
  REPORT_PUBLISHED: 'REPORT_PUBLISHED',
  REPORT_FOR_APPROVAL: 'REPORT_FOR_APPROVAL',
  TREND_MENTION_COMMENT: 'TREND_MENTION_COMMENT',
};

export const MODAL_PORTAL_ID = 'modal-portal';

export const NOTIF_DURATION = 60000;

export const CURRENT_YEAR = new Date().getFullYear();

export const REPORT_STATUSES = {
  APPROVED: 'approved',
  PENDING: 'pending',
  DECLINED: 'declined',
  DRAFT: 'draft',
};

export const POPUP_TYPE = {
  MESSAGE: 'message',
  FORM: 'form',
};

export const OS_TYPES = {
  WINDOWS: 'Win',
  MACOS: 'Mac',
  UNIX: 'X11',
  LINUX: 'Linux',
};

export const MAX_METRIC_VALUE = 10_000_000_000;

export const BIG_NUMS = {
  THOUSAND: 1000,
  MILLION: 1_000_000,
  BILLION: 1_000_000_000,
  TRILLION: 1_000_000_000_000,
};

export const WS_STATUSES = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};

export const MS_IN_DAY = 1000 * 3600 * 24;

export const COLLECTION_TYPE = {
  TRENDS: 'trends',
  PEOPLE: 'people',
};
